import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useUserOrganization } from '@/hooks/useUserOrganization'
import type { DashboardOrderDetail } from '../types/dashboard.types'

export function useOrderDetail(orderId: number | null) {
  const { data: membership } = useUserOrganization()
  const orgId = membership?.organization_id

  return useQuery({
    queryKey: ['dashboard-order-detail', orgId, orderId],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('delivery')
        .rpc('dashboard_order_detail', {
          p_org_id: orgId!,
          p_order_id: orderId!,
        })

      if (error) {
        console.error('Order detail error:', error)
        throw error
      }

      const rows = (data || []) as DashboardOrderDetail[]
      return rows[0] ?? null
    },
    enabled: !!orgId && !!orderId,
    staleTime: 60_000,
  })
}
